document.addEventListener('DOMContentLoaded', function() {
  const bullets = new Swiper("#bullets", {
    // 基本設定
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    speed: 1000,

    // スライド切り替えの設定
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },

    // 自動再生の設定
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },

    // ナビゲーションボタンの設定
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },

    // ページネーションの設定
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true
    },

    // スライド切り替え時のイベント
    on: {
      // 初期化時に最初のスライドにアニメーションを適用
      init: function() {
        const activeSlide = this.slides[this.activeIndex];
        const content = activeSlide.querySelector('.slide-content');
        if (content) {
          content.style.opacity = '1';
          content.style.animation = 'fadeIn 2s ease-out forwards';
        }
      },

      // スライドが切り替わった後に実行
      slideChangeTransitionStart: function() {
        // アニメーションと不透明度をリセット
        this.slides.forEach(slide => {
          const content = slide.querySelector('.slide-content');
          if (content) {
            content.style.opacity = '0';
            content.style.animation = 'none';
          }
        });
      },

      // 新しいスライドがアクティブになったときにアニメーションを適用
      slideChangeTransitionEnd: function() {
        const activeSlide = this.slides[this.activeIndex];
        const content = activeSlide.querySelector('.slide-content');
        if (content) {
          content.style.opacity = '1';
          content.style.animation = 'fadeIn 2s ease-out forwards';
        }
      }
    }
  });
});
